<template>
  <div class="informationCollectForm">
    <el-form :model="submitForm" :rules="rules" ref="submitForm" label-width="80px">
      <div class="box three">
        <el-form-item label="姓名" prop="name">
          <el-input size="mini" v-model="submitForm.name"></el-input>
        </el-form-item>
        <el-form-item label="高考省份" prop="province">
          <el-select size="mini" v-model="submitForm.province" placeholder="请选择">
            <el-option
              v-for="(item,index) in provinceList"
              :key="index"
              :label="item.name"
              :value="item.provinceId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="phone" label="联系电话" prop="phone">
          <el-input
            size="mini"
            v-model="submitForm.phone"
            maxlength="11"
            @blur="phoneType"
          ></el-input>
          <p class="alertB" v-show="phoneFalse">
            <span v-text="phoneRule"></span>
          </p>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button type="primary" @click="submit('submitForm')">提交信息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import { submitInfo } from '../../../config'
  import provinceList from '../../../json/provinceList.json'
  import {message} from 'element-ui'
  export default {
    name: "informationCollect",  // 信息采集
    data() {
      return {
        submitForm: {
          name: '',  // 姓名
          phone: null,  // 联系电话
          province: null,  // 高考省份
        },
        phoneFalse: false,
        phoneRule: '请输入正确手机号',
        rules: {
          name: [{ required: true, message: '请填写正确姓名', trigger: 'blur' }],
          // phone: [{ required: true, message: '请填写正确手机号', trigger: 'blur' }],
          province: [{ required: true, message: '请选择您的高考省份', trigger: 'change' }],
        },
        provinceList: []
      }
    },
    mounted() {
      this.provinceList = provinceList
    },
    methods: {
      // 提交信息
      async submitInfo() {
        const res = await submitInfo({
          'realName': this.submitForm.name,
          'provinceCode': this.submitForm.province,
          'mobile': this.submitForm.phone
        });
        if(res.status) {
          let timer = setTimeout(() => {
            this.$layer.alert(
                '提交成功',
                {
                  icon: 2
                });
            clearTimeout(timer)
          },1000)
        }
      },
      // 手机号验证
      phoneType() {
        let re = /^1[3456789]{1}\d{9}$/;
        let str = this.submitForm.phone;
        if(re.test(str)){
          this.phoneFalse = false;
        }else {
          this.phoneFalse = true;
        }
      },
      submit(formName) {
        this.$refs[formName].validate((valid) => {
          if(!this.phoneFalse) {
            if (valid) {
              this.submitInfo();
            } else {
              return false;
            }
          }
        });
      }
    }
  }
</script>

<style lang="scss">
  .el-dialog{
    max-width: 600px;
    .el-dialog__header, .el-dialog__body{
      padding: 0;
    }
    .dialogBox{
      padding: 10px;
      .dialogTitle{
        margin-bottom: 10px;
        h4{
          font-size: 16px;
          margin: 10px 0;
          font-weight: normal;
        }
      }
      .dialogContent{
        padding: 20px 10px;
        p{
          margin: 0;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  .informationCollectForm{
    max-width: 1200px;
    margin: auto;
    .el-button{
      display: block;
      margin: auto;
      width: 97%;
      background-color: #0060ff;
    }
    .box.three{
      display: flex;
      .el-form-item{
        width: 33%;
        padding: 10px 20px;
        .el-select{
          display: block;
        }
      }
    }
    .phone{
      position: relative;
      p.alertB{
        position: absolute;
        bottom: -27px;
        font-size: 0.8rem;
        color: #f56c6c;
      }
    }
  }
</style>
